// Temporary project system: sessions (audio blob + chops + video link) saved
// in IndexedDB so they survive reloads. Metadata and blob live in the same
// record — projects are few and small (an mp3 each).

const DB_NAME = 'sampleband-projects';
const STORE = 'projects';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) {
        req.result.createObjectStore(STORE, { keyPath: 'id' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(db, mode, fn) {
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const req = fn(store);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

/**
 * @param {Object} project
 * @param {string} project.id
 * @param {string} project.name
 * @param {Blob} project.audioBlob - the session's audio (File is a Blob)
 * @param {string} project.audioName
 * @param {string} project.audioType
 * @param {Array} project.chops - [{id, key, start, end?}]
 * @param {string|null} project.videoUrl - backend /media URL if YouTube-sampled
 * @param {string|null} project.youtubeTitle
 */
export async function saveProject(project) {
  const db = await openDb();
  await tx(db, 'readwrite', (s) => s.put({ savedAt: Date.now(), ...project }));
  db.close();
}

export async function listProjects() {
  const db = await openDb();
  const all = await tx(db, 'readonly', (s) => s.getAll());
  db.close();
  return (all || []).sort((a, b) => (b.savedAt || 0) - (a.savedAt || 0));
}

export async function getProject(id) {
  const db = await openDb();
  const p = await tx(db, 'readonly', (s) => s.get(id));
  db.close();
  return p || null;
}

export async function deleteProject(id) {
  const db = await openDb();
  await tx(db, 'readwrite', (s) => s.delete(id));
  db.close();
}
